var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs text-gray-800 bg-amarelo p-1 mt-2.5 rounded font-bold py-3 mb-2 border border-solid border-roxo z-2"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.texto)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }